import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Hive Case Study | Canny';
const Description =
  'Read about how Hive uses Canny to collaborate across departments and increase their NPS.';
const Image = 'https://canny.io/images/88ffedfc7492b0896a70e26233754e7e.jpg';

export default class HiveLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/hive' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
